import { gql } from "@apollo/client";

export const CREATE_AGENT_USER = gql`
  mutation CreateAgentUser(
    $email: String!
    $password: String
    $username: String!
    $phone: String
    $address: String
    $city: String
    $state: String
    $country: String
    $zipcode: String
    $isPlatformAdmin: Boolean
  ) {
    createAgentUser(
      email: $email
      password: $password
      username: $username
      phone: $phone
      address: $address
      city: $city
      state: $state
      country: $country
      zipcode: $zipcode
      isPlatformAdmin: $isPlatformAdmin
    ) {
      id
      username
      email
      phone
      address
      city
      state
      country
      zipcode
      status
      isAgent
      isPlatformAdmin
      isDefaultConcierge
    }
  }
`;

export const SET_AGENT_USER_ACTIVE = gql`
  mutation SetAgentUserActive($userId: ID!, $isActive: Boolean!) {
    setAgentUserActive(userId: $userId, isActive: $isActive) {
      id
      username
      email
      phone
      address
      city
      state
      country
      zipcode
      status
      isAgent
      isPlatformAdmin
      isDefaultConcierge
    }
  }
`;

export const SET_AGENT_USER_PLATFORM_ADMIN = gql`
  mutation SetAgentUserPlatformAdmin($userId: ID!, $isPlatformAdmin: Boolean!) {
    setAgentUserPlatformAdmin(userId: $userId, isPlatformAdmin: $isPlatformAdmin) {
      id
      username
      email
      phone
      address
      city
      state
      country
      zipcode
      status
      isAgent
      isPlatformAdmin
      isDefaultConcierge
    }
  }
`;

export const SUBMIT_AGENT_APPLICATION = gql`
  mutation SubmitAgentApplication(
    $email: String!
    $username: String!
    $phone: String
    $address: String
    $city: String
    $state: String
    $country: String
    $zipcode: String
    $serviceAreas: String
    $specialties: String
    $notes: String
  ) {
    submitAgentApplication(
      email: $email
      username: $username
      phone: $phone
      address: $address
      city: $city
      state: $state
      country: $country
      zipcode: $zipcode
      serviceAreas: $serviceAreas
      specialties: $specialties
      notes: $notes
    ) {
      id
      status
      createdAt
      email
      username
    }
  }
`;

export const REVIEW_AGENT_APPLICATION = gql`
  mutation ReviewAgentApplication(
    $applicationId: ID!
    $decision: String!
    $reviewNotes: String
    $password: String
  ) {
    reviewAgentApplication(
      applicationId: $applicationId
      decision: $decision
      reviewNotes: $reviewNotes
      password: $password
    ) {
      id
      status
      reviewedAt
      reviewNotes
      approvedUserId
      approvedUser {
        id
        username
        email
      }
    }
  }
`;
